<template>
  <div
    class="lesson-list"
    :class="{
      'h5-lesson-list': isH5,
      'electron-lesson-list': isElectron,
    }"
  >
    <el-collapse v-model="activeNames" class="collapse-wrap">
      <el-collapse-item
        v-for="(unit, unitIndex) in unitList"
        :key="unit.id"
        :title="unit.unit_name"
        :name="unit.id"
      >
        <template slot="title">
          <div class="unit-name">
            <div class="name-text ellipsis">{{ unit.unit_name }}</div>
            <div class="unit-arrow">
              <span v-if="unit.lesson_list">{{
                unit.lesson_list.length || 0
              }}</span>
              <span
                class="arrow"
                :class="{ collapsed: activeNames.includes(unit.id) }"
              ></span>
            </div>
          </div>
        </template>
        <template v-if="unit.lesson_list && unit.lesson_list.length">
          <div class="lesson-list-wrap">
            <div
              class="lesson-item"
              :class="{
                'active-lesson-item': lesson.id === activeLesson.id,
              }"
              v-for="(lesson, lessonIndex) in unit.lesson_list"
              :key="lesson.id"
              @click="handleClickLesson(lesson)"
            >
              <div class="icon">
                <span
                  v-if="lesson.canTrial && !isRegistered"
                  class="lesson-type-tag can-trial"
                  >试学</span
                >
                <!-- 直播课 -->
                <template v-else-if="[2, 4].includes(lesson.lesson_type)">
                  <span
                    v-if="lesson.roomStatus === 2"
                    class="lesson-type-tag living"
                  >
                    <img src="../../../assets/images/living-tag.gif" alt=""
                  /></span>
                  <span
                    v-else
                    class="lesson-type-tag"
                    :class="{ 'live-tag': lesson.liveStatus !== 1 }"
                    >{{
                      [1].includes(lesson.liveStatus) ? "视频" : "直播"
                    }}</span
                  >
                </template>
                <!-- 点播课 -->
                <template v-else-if="lesson.lesson_type === 1">
                  <span class="lesson-type-tag saas-demand-color">视频</span>
                </template>
              </div>
              <div class="lesson-info">
                <div class="name">{{ lesson.lesson_name }}</div>
                <div class="other">
                  <!-- 私教课-老师列表 -->
                  <template v-if="lesson.lesson_type === 4">
                    <div
                      v-if="isH5"
                      :id="'teacher' + lesson.id"
                      class="teacher"
                      :class="{
                        isOverflowing: isOverflowing('teacher' + lesson.id),
                      }"
                    >
                      <span>
                        {{ lesson.teachers }}
                      </span>
                      <img
                        @click.stop="showTeacherInfo(lesson.teachers)"
                        class="show-all"
                        src="../../../assets/images/arrow-right.png"
                        alt=""
                      />
                    </div>
                    <el-tooltip
                      v-else
                      popper-class="moguo-tooltip video-play-lesson-list"
                      class="item"
                      effect="dark"
                      :content="lesson.teachers"
                      placement="top"
                      :disabled="!lesson.isShowTooltip"
                    >
                      <div
                        class="teacher"
                        @mouseenter="
                          visibilityChange(
                            $event,
                            lesson,
                            unitIndex,
                            lessonIndex
                          )
                        "
                      >
                        {{ lesson.teachers }}
                      </div>
                    </el-tooltip>
                  </template>
                  <div v-else class="teacher">
                    {{ lesson.org_nickname }}
                  </div>
                  <div class="lesson-time">
                    <span v-if="[2, 4].includes(lesson.lesson_type)">
                      {{ handleLiveTime(lesson) }}
                    </span>
                    <span v-else>{{ handleDuration(lesson.duration) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { isH5, isHXApp, isMobile } from "@saas/components/src/utils/utils";
import moment from "moment";
export default {
  props: {
    unitList: {
      type: Array,
      default: () => [],
    },
    activeLesson: {
      type: Object,
      default: () => {},
    },
    isRegistered: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      isElectron: window.isElectron,
      activeNames: [],
    };
  },
  watch: {
    unitList: {
      handler(val) {
        if (this.unitList?.length) {
          this.activeNames = this.unitList.map((item) => item.id);
        } else {
          this.activeNames = [];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    visibilityChange(event, lesson, unitIndex, lessonIndex) {
      if (lesson.isShowTooltip !== undefined) return;
      const ev = event.target;
      let ev_size = ev.scrollWidth;
      let content_size = ev.clientWidth;
      if (ev_size > content_size) {
        this.$set(
          this.unitList[unitIndex].lesson_list[lessonIndex],
          "isShowTooltip",
          true
        );
      } else {
        this.$set(
          this.unitList[unitIndex].lesson_list[lessonIndex],
          "isShowTooltip",
          false
        );
      }
    },
    // 判断元素是否溢出
    isOverflowing(name) {
      this.$nextTick(() => {
        let ele = document.querySelector(`#${name} span`);
        if (ele) {
          let { scrollWidth, clientWidth } = ele;
          if (scrollWidth > clientWidth) {
            ele.parentElement.classList.add("isOverflowing");
          } else {
            ele.parentElement.classList.remove("isOverflowing");
          }
        } else {
          ele.parentElement.classList.remove("isOverflowing");
        }
      });
    },
    showTeacherInfo(teachers) {
      this.$confirm(teachers, "", {
        showCancelButton: false,
        confirmButtonText: "确定",
        customClass: "saas-confirm-message lesson-teacher-info-confirm",
        confirmButtonClass: "confirm-btn",
        closeOnClickModal: false,
      })
        .then(() => {})
        .catch(() => {});
    },
    // 点击课时
    handleClickLesson(lesson) {
      this.$emit("changeLesson", lesson);
    },
    handleDuration(milliseconds) {
      if (!milliseconds) {
        return "";
      }
      const totalSeconds = Math.floor(milliseconds);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      if (!hours) {
        return `${minutes.toString().padStart(2, "0")}:${seconds
          .toString()
          .padStart(2, "0")}`;
      } else {
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      }
    },
    handleLiveTime(lesson) {
      // console.log(lesson);
      return `${moment(lesson.live_start_time * 1000).format(
        "MM.DD HH:mm"
      )}-${moment(lesson.live_end_time * 1000).format("HH:mm")}`;
    },
  },
  computed: {},
};
</script>

<style scoped lang="scss">
// 课程类型标签
.lesson-type-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #efefef;
  font-weight: 400;
  font-size: 11px;
  color: #747573;
  line-height: 1;
  padding: 3px 4px 4px;
  background: transparent;
  width: auto;
  margin-right: 6px;
  &.live-tag {
    color: #00c89d;
    border: 1px solid #b8e7dd;
  }
  &.can-trial {
    color: #f03349;
    border: 1px solid #feadb7;
  }
  &.living {
    width: 30px;
    border: 1px solid #b8e7dd;
    padding-top: 2px;
    padding-bottom: 2px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.lesson-list {
  padding: 12px 8px 12px 12px;
  margin-right: 4px;
  max-height: calc(100vh - 321px);
  overflow: auto;
  &:hover::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .collapse-wrap ::v-deep {
    border: none;
    .el-collapse-item {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      .el-collapse-item__arrow {
        display: none;
      }
      .el-collapse-item__header {
        border: none;
        font-weight: 500;
        font-size: 14px;
        height: 38px;
        color: #0d1400;
        background: unset;
        background: RGBA(243, 252, 247, 1);
        border-radius: 6px;

        .unit-name {
          word-break: break-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding-left: 14px;
          .name-text {
            width: 0;
            flex: 1;
            display: inline-block;
          }
          .unit-arrow {
            margin-right: 6px;
            width: 31px;
            height: 18px;
            padding-right: 6px;
            background: #ffffff;
            border-radius: 9px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-size: 11px;
            .arrow {
              width: 8px;
              height: 6px;
              margin-left: 4px;
              background: url("../../../assets/images/arrow.png");
              background-repeat: no-repeat;
              background-size: 100%;
              transform: rotate(180deg);
              &.collapsed {
                transform: rotate(0deg);
              }
            }
          }
        }
        i {
          color: #0d1400;
          font-size: 12px;
          font-weight: bold;
        }
      }
      .el-collapse-item__wrap {
        background: unset;
        border: none;
        .el-collapse-item__content {
          padding: 0;
        }
      }
    }
  }
  .lesson-list-wrap {
    .lesson-item {
      cursor: pointer;
      box-sizing: border-box;
      width: 100%;
      height: 65px;
      padding: 12px 12px 12px 4px;
      display: flex;
      align-items: flex-start;
      border-bottom: 1px solid #ffffff;
      border-radius: 6px;
      border: 1px solid rgba(0, 200, 157, 0);
      .lesson-info {
        flex: 1;
        overflow: hidden;
        .name {
          width: 100%;
          font-weight: 400;
          font-size: 14px;
          color: #0d1400;
          line-height: 18px;
          word-break: break-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .other {
          margin-top: 8px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .teacher {
            font-weight: 400;
            font-size: 12px;
            color: #515350;
            line-height: 17px;
            word-break: break-all;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 5px;
            flex: 1;
          }
          .lesson-time {
            font-weight: 400;
            font-size: 12px;
            color: #515350;
            line-height: 17px;
            max-width: 150px;
          }
        }
      }
    }
    .active-lesson-item {
      border: 1px solid rgba(0, 200, 157, 0.2);
      background: linear-gradient(
        133deg,
        rgba(230, 254, 241, 0.9) 0%,
        rgba(206, 255, 228, 0.9) 100%
      );
    }
  }
}
.lesson-list::-webkit-scrollbar {
  width: 4px;
}
.lesson-list::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 2px;
}

.h5-lesson-list {
  // padding: 12px 14px;
  padding: 0;
  .collapse-wrap ::v-deep {
    border: none;
    .el-collapse-item {
      margin-bottom: 0.3733rem;
      .el-collapse-item__header {
        font-weight: 500;
        font-size: 0.4267rem;
        color: #0d1400;
        background: unset;
        background: rgba(244, 252, 247, 0.8);
        border-radius: 0.16rem;

        .unit-name {
          word-break: break-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 1;
          padding-left: 0.3733rem;
        }
        i {
          color: #0d1400;
          font-size: 0.24rem;
        }
      }
      .el-collapse-item__wrap {
        background: unset;
        .el-collapse-item__content {
          padding: 0;
        }
      }
    }
  }
  .lesson-list-wrap {
    .lesson-item {
      cursor: pointer;
      box-sizing: border-box;
      width: 100%;
      height: 2.08rem;
      padding: 0.3733rem 0.3733rem 0.3733rem 0.0533rem;
      display: flex;
      align-items: flex-start;
      border-bottom: 1px solid #ffffff;
      border-radius: 0.16rem;
      border: 1px solid rgba(0, 200, 157, 0);
      .lesson-info {
        flex: 1;
        overflow: hidden;
        .name {
          width: 100%;
          font-weight: 400;
          font-size: 0.4267rem;
          color: #0d1400;
          line-height: 0.5867rem;
          word-break: break-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .other {
          margin-top: 0.2133rem;
          display: flex;
          flex-direction: row;
          align-items: center;
          .teacher {
            width: 0;
            flex: 1;
            font-weight: 400;
            font-size: 0.3733rem;
            color: #515350;
            line-height: 0.5333rem;
            word-break: break-all;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 0.53rem;
            span {
              flex: 1;
              width: 0;
              word-break: break-all;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .show-all {
              display: none;
              height: 0.31rem;
              padding: 0.1rem 0.1rem 0;
            }
            &.isOverflowing {
              .show-all {
                display: inline-block;
              }
              // position: relative;
              // padding-left: 0.16rem;
            }
            // &.isOverflowing::after {
            //   position: absolute;
            //   bottom: 0.13rem;
            //   right: 0;
            //   content: "";
            //   width: 0.16rem;
            //   height: 0.21rem;
            //   background: url("../../../assets/images/arrow-right.png");
            //   background-size: 100% 100%;
            // }
          }
          .lesson-time {
            font-size: 0.3733rem;
            color: #515350;
            line-height: 0.5333rem;
          }
        }
      }
    }
    .active-lesson-item {
      border: 1px solid rgba(0, 200, 157, 0.2);
      background: linear-gradient(
        133deg,
        rgba(230, 254, 241, 0.9) 0%,
        rgba(206, 255, 228, 0.9) 100%
      );
    }
  }
}
</style>
<style lang="scss">
.moguo-tooltip.video-play-lesson-list.el-tooltip__popper {
  max-width: 300px !important;
}
.lesson-teacher-info-confirm.el-message-box.saas-confirm-message {
  .el-message-box__content {
    font-weight: 500;
    font-size: 14px;
    color: #0d1400;
    line-height: 20px;
  }
  .confirm-btn {
    width: 7.44rem !important;
    border-radius: 20px !important;
  }
}
</style>
